export default function SkeletonPengumuman() {
  return (
    <div className="flex flex-col gap-y-6">
      {/* 1. Skeleton Alert Top (Pengganti Alert UKT/Kelulusan) */}
      <div className="rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-950 p-4 sm:p-5 flex items-start gap-4">
        <div className="skeleton h-10 w-10 shrink-0 rounded-full" />
        <div className="space-y-3 w-full mt-1">
          <div className="skeleton h-5 w-[40%] rounded-md" />
          <div className="space-y-2">
            <div className="skeleton h-4 w-full rounded-md" />
            <div className="skeleton h-4 w-[85%] rounded-md" />
            <div className="skeleton h-4 w-[60%] rounded-md" />
          </div>
        </div>
      </div>

      {/* 2. Main Grid Layout (Kiri 8, Kanan 4) */}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
        {/* === LEFT COLUMN (Col-8) === */}
        <div className="lg:col-span-8 space-y-6">
          <div className="rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-950 shadow-sm overflow-hidden">
            {/* Header Profil Skeleton */}
            <div className="p-6 border-b border-slate-100 dark:border-slate-800 bg-slate-50/50 dark:bg-slate-900/50 flex flex-col sm:flex-row justify-between gap-4 items-start sm:items-center">
              <div className="space-y-2 w-full">
                <div className="skeleton h-6 w-[200px] rounded-md" />
                <div className="skeleton h-4 w-[300px] rounded-md" />
              </div>
              <div className="skeleton h-8 w-[150px] shrink-0 rounded-full" />
            </div>

            <div className="p-6">
              <div className="flex flex-col md:flex-row gap-8">
                {/* Avatar Skeleton */}
                <div className="flex flex-row md:flex-col items-center md:items-start gap-4 min-w-[200px]">
                  <div className="skeleton w-20 h-20 md:w-28 md:h-28 rounded-full border-4 border-white dark:border-slate-900" />
                  <div className="space-y-2 w-full">
                    <div className="skeleton h-5 w-[150px] rounded-md" />
                    <div className="skeleton h-4 w-[100px] rounded-md" />
                    <div className="skeleton h-6 w-[120px] rounded-md mt-2" />
                  </div>
                </div>

                {/* Content Section Skeleton (Academic & Financial) */}
                <div className="flex-1 w-full space-y-6">
                  {/* Academic Boxes */}
                  <div className="bg-slate-50 dark:bg-slate-900/50 p-4 rounded-xl border border-slate-100 dark:border-slate-800 grid grid-cols-1 sm:grid-cols-2 gap-6">
                    <div className="space-y-2">
                      <div className="skeleton h-3 w-[60px] rounded-md" />
                      <div className="skeleton h-5 w-[180px] rounded-md" />
                    </div>
                    <div className="space-y-2">
                      <div className="skeleton h-3 w-[80px] rounded-md" />
                      <div className="skeleton h-5 w-[200px] rounded-md" />
                    </div>
                  </div>

                  {/* Financial Boxes */}
                  <div className="space-y-4 pt-2">
                    <div className="flex justify-between items-end border-b border-dashed border-slate-200 dark:border-slate-700 pb-2">
                      <div className="skeleton h-4 w-[100px] rounded-md" />
                      <div className="skeleton h-6 w-[140px] rounded-md" />
                    </div>
                    <div className="flex justify-between items-end border-b border-dashed border-slate-200 dark:border-slate-700 pb-2">
                      <div className="skeleton h-4 w-[120px] rounded-md" />
                      <div className="skeleton h-6 w-[140px] rounded-md" />
                    </div>
                    <div className="flex justify-between items-center bg-slate-50 dark:bg-slate-900/50 p-3 rounded-lg border border-slate-100 dark:border-slate-800 mt-4">
                      <div className="skeleton h-5 w-[100px] rounded-md" />
                      <div className="skeleton h-8 w-[160px] rounded-md" />
                    </div>
                  </div>

                  {/* File Upload Box */}
                  <div className="space-y-3 mt-6">
                    <div className="flex justify-between items-center">
                      <div className="skeleton h-5 w-[150px] rounded-md" />
                      <div className="skeleton h-4 w-[100px] rounded-md" />
                    </div>
                    <div className="skeleton h-40 w-full rounded-xl" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Tabel Sanggah Berkas Skeleton */}
          <div className="rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-950 shadow-sm overflow-hidden mt-8">
            <div className="p-4 border-b border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-900/50 flex justify-between items-center">
              <div className="flex items-center gap-2">
                <div className="skeleton h-5 w-5 rounded-md" />
                <div className="skeleton h-6 w-[200px] rounded-md" />
              </div>
              <div className="skeleton h-6 w-[100px] rounded-full" />
            </div>
            <div className="divide-y divide-slate-100 dark:divide-slate-800">
              {[...Array(3)].map((_, i) => (
                <div key={i} className="p-4 flex gap-4 items-start">
                  <div className="skeleton h-6 w-6 rounded-full shrink-0" />
                  <div className="space-y-2 w-full max-w-[250px]">
                    <div className="skeleton h-5 w-full rounded-md" />
                    <div className="skeleton h-4 w-[80%] rounded-md" />
                    <div className="skeleton h-6 w-[80px] rounded-full mt-2" />
                  </div>
                  <div className="skeleton h-20 w-full flex-1 rounded-lg" />
                  <div className="space-y-2 w-[120px] shrink-0">
                    <div className="skeleton h-8 w-full rounded-md" />
                    <div className="skeleton h-8 w-full rounded-md" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* === RIGHT COLUMN (Col-4) === */}
        <div className="lg:col-span-4 space-y-4">
          <div className="skeleton h-4 w-[150px] rounded-md mb-2" />

          {/* Action Cards Skeleton (Generate Invoice, Cetak NIM) */}
          {[...Array(3)].map((_, i) => (
            <div
              key={i}
              className="rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-950 p-4 shadow-sm flex items-start gap-4 h-[120px]"
            >
              <div className="skeleton h-12 w-12 rounded-lg shrink-0" />
              <div className="space-y-3 w-full pt-1">
                <div className="skeleton h-5 w-[70%] rounded-md" />
                <div className="space-y-2">
                  <div className="skeleton h-3 w-full rounded-md" />
                  <div className="skeleton h-3 w-[85%] rounded-md" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
